// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table__wrapper{padding:0}.table__cell{margin-right:3rem;padding:1.6rem 0;width:365px;width:36.5rem}.table__cell--action{margin-left:auto;margin-right:0;width:20px}._2RKPc{display:-ms-flexbox;display:flex;width:100%;-ms-flex-positive:1;flex-grow:1}._2RKPc>:first-child{border-right:2px solid #e0e8f2;padding-right:1.6rem}._2RKPc>:last-child{padding-left:1.6rem}._17tDz{height:32px;height:3.2rem;padding:8px;width:32px;width:3.2rem}._17tDz .btn-inner>div{width:auto}._17tDz svg{height:24px;width:24px}._3c0IU{width:50%;-ms-flex-positive:1;flex-grow:1}.ipjqf{display:-ms-flexbox;display:flex;margin-left:auto;margin-right:-20px}.ipjqf svg{display:block;height:20px;height:2rem;left:-30px;left:-3rem;position:relative;top:8px;top:.8rem;width:20px;width:2rem}", ""]);
// Exports
exports.locals = {
	"tables": "_2RKPc",
	"table__cell__actionButton": "_17tDz",
	"table": "_3c0IU",
	"header__search": "ipjqf"
};
module.exports = exports;
